import React from 'react';
import ClaimAmountIcon from 'products/nomad_insurance/assets/img/claims/claim-amount.svg';
import PropTypes from 'prop-types';
import { Icon } from './styled';
import { InfoText } from '../../styled';

export const ClaimAmountInfo = ({ claim }) => {
  const amount =
    claim.approvedPayoutAmount || claim.claimAmount || claim.estimatedCost || 0;

  const claimFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency:
      claim.approvedPayoutCurrency ||
      claim.claimCurrency ||
      claim.estimatedCostCurrency ||
      'USD'
  });

  return (
    <InfoText>
      <Icon src={ClaimAmountIcon} alt="claim amount" />
      {claimFormatter.format(amount)}
    </InfoText>
  );
};

ClaimAmountInfo.propTypes = {
  claim: PropTypes.any.isRequired
};
